import React from "react"
import {
    RangeSlider,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderThumb,
} from "@chakra-ui/react"
import { useColors } from "@mallardbay/lib-react-components"

interface Props {
    readonly min: number
    readonly max: number
    readonly value: [number, number]
    readonly onChange: (newValue: [number, number]) => void
}

export default function Slider({ min, max, value, onChange }: Props) {
    const colors = useColors()

    const thumbProps = {
        backgroundColor: colors.text,
        boxSize: 6,
    }

    return (
        <RangeSlider
            defaultValue={value}
            min={min}
            max={max}
            onChange={onChange}
        >
            <RangeSliderTrack>
                <RangeSliderFilledTrack backgroundColor={colors.text} />
            </RangeSliderTrack>
            <RangeSliderThumb {...thumbProps} index={0} />
            <RangeSliderThumb {...thumbProps} index={1} />
        </RangeSlider>
    )
}
